<template>
  <div class="cont">
    <div class="h3">
      自有模板
    </div>
    <div class="neiRbox">
      <div class="titleBox">
        <div class="tabBox"></div>
        <div class="searchBox">
          <input type="text" v-model="search" placeholder="请输入你要搜索的内容">
          <div class="btn" @click="keyWord"><img src="../../../../assets/images/sousuo.png" alt="">搜索</div>
        </div>
      </div>
      <div class="listBox">
        <div class="tabelTitle">
          <div class="titleLeft">
            模板名称
          </div>
          <div class="titleRight">
            <div class="titleRightCenOne" style="width: 140px;">
              标签
            </div>
            <div class="titleRightCenOne">
              引用
            </div>
            <div class="titleRightCenOne">
              浏览
            </div>
            <div class="titleRightCenTwo">
              操作
            </div>
          </div>
        </div>
        <div v-if="list.length > 0" style="padding-bottom: 100px;">
          <div class="tabelBox" v-for="item in list" :key="item.id">
            <div class="tabelBoxTitleLeft" @click="yl(item.id)">
              {{item.title}}
            </div>
            <div class="tabelBoxTitleRight">
              <div class="titleRightCenOne" style="width: 140px;margin-right: 10px;text-align: center;line-height: 30px;overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;">
                {{item.lable}}
              </div>
              <div class="tabelBoxTitleRightCenOne">
                {{item.quotenum}}次
              </div>
              <div class="tabelBoxTitleRightCenOne">
                {{item.rednum}}次
              </div>
              <div class="tabelBoxTitleRightCenTwo">
                <span class="tabelBtnYl" @click="yl(item.id)">预览</span>
                <span class="tabelBtnBj" @click="go(item.id)">编辑</span>
                <a :href="item.path_url" class="tabelBtnYl" style="margin-left: 5px;">下载</a>
                <span class="tabelBtndel" @click="mbDel(item.id)">删除</span>
              </div>
            </div>
          </div>
          <div class="pageBox">
            <span @click="page.pageNum = 1">首页</span>
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-size="page.pageSize"
                    :current-page.sync="page.pageNum"
                    layout="prev, pager, next"
                    :total="page.pageTotal">
            </el-pagination>
            <span @click="page.pageNum = page.pageCount">尾页</span>
          </div>
        </div>
        <div class="tabelNo" v-else>暂无更多模板...</div>
      </div>
    </div>
    <notice v-if="!isDetail" v-bind:idProps="id" v-bind:is-detail="isDetail" @watchState="watchState"></notice>
  </div>
</template>

<script>
  import notice from '../../../../components/notice'
  export default {
    name: "zyMuBan",
    data() {
      return {
        isDetail: true,
        id: 2,
        title: '自有模板',
        search: '', // 搜索
        spanNum: 1, // tab切换背景
        list: [],
        page: {
          pageNum: 1, // 当前页数
          pageSize: 10, // 每页显示条数
          pageTotal: 4, // 总条数
          pageCount: 1, // 总页数
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if(!this.user){
        this.$router.push("/login")
      }
      // this.$emit('setAct', 0)
      this.title = this.$router.history.current.queryname
      console.log(this.$router.history.current.queryname)
      this.getList()
    },
    methods: {
      getList() {
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        this.$api.apiAdmin.GetMyArt({
          mid: this.user.mid,
          keyword: this.search,
          page: this.page.pageNum,
          pagesize: this.page.pageSize
        }).then(res => {
          console.log(res)
          this.list = res.data.data
          this.page.pageTotal = res.data.pageinfo.count
          this.page.pageCount = Math.ceil(Number(res.data.pageinfo.count) / Number(this.page.pageSize))
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 自有模板编辑
      go(id){
        this.$router.push({
          path:'/home/zncgBanKuai',
          query:{
            bjid: id
          }
        })
      },
      // 删除自由模板
      mbDel(id){
        this.$confirm('<p style="color: #0a2240;margin: 30px 0; ">你确定要删除这个模板吗?</p>', '温馨提示', {
          dangerouslyUseHTMLString:true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: '',
          center: true,
          roundButton:true,
          cancelButtonClass:"scqx",
          confirmButtonClass:"scqd",
          showClose:false,
        }).then(() => {
          this.$api.apiAdmin.DelMoban({
            mid: this.user.mid,
            id: id
          }).then(res => {
            console.log(res)
            this.$messageSuccess(res.msg);
            this.getList()
          }).catch(res => {
            this.$messageError(res.msg);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      // 预览
      yl(id) {
        this.id = String(id)
        this.isDetail = false
      },
      // 详情关闭
      watchState(blon) {
        this.isDetail = blon
      },
      // 点击分页
      handleSizeChange(num) {
        this.page.pageNum = num
      },
      // 选择页数
      handleCurrentChange(num) {
        this.page.pageNum = num
      },
      // 搜索
      keyWord() {
        if(this.page.pageNum === 1){
          this.setPath()
        }else {
          this.page.pageNum = 1
        }
      },
      // 修改路径
      setPath() {
        this.$router.push({
          path: '/home/mbzxBanKuai/zyMuBan',
          query: {
            pageNum: this.page.pageNum,
            key: this.search
          }
        })
      }
    },
    components: {
      notice
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.getList()
      }
    }
  }
</script>

<style scoped lang="scss">
  .bgc {
    background-color: #d50807 !important;
    color: #ffffff !important;
  }
  .h3 {
    position: absolute;
    top: 0;
    width: 100%;
    height: 46px;
    line-height: 46px;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    border-bottom: 1px solid #e8e8e8;
    padding-left: 42px;
    background: #fff url("../../../../assets/images/fangxian.png") no-repeat left  center;
    background-position-x: 26px;
    background-size: 7px 18px;
    z-index: 10;
  }
  .cont {
    width: 997px;
    height: 100%;
    padding-top: 46px;
    overflow-y: scroll;
    .neiRbox  {
      width: 100%;
      padding: 28px;
      .titleBox {
        width: 100%;
        height: 36px;
        margin-bottom: 50px;
        display: flex;
        justify-content: space-between;
        .tabBox {
          min-width: 300px;
          padding-top: 10px;

          span {
            font-size: 18px;
            font-weight: bold;
            padding: 2px 20px 4px 20px;
            margin-right: 10px;
            cursor: pointer;
            border-radius: 16px;
          }
        }

        .searchBox {
          position: relative;
          width: 318px;
          height: 36px;
          border-radius: 18px;
          input {
            width: 100%;
            height: 36px;
            border-radius: 18px;
            border: none;
            outline: none;
            text-indent: 20px;
            padding-right: 120px;
            background-color: #f2f2f2;
          }

          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 107px;
            height: 36px;
            background-image: linear-gradient(37deg,
              #ffb400 0%,
              #fc7802 100%),
            linear-gradient(
                #0080dc,
                #0080dc);
            background-blend-mode: normal,
            normal;

            box-shadow: -6px 6px 18px 0px
            rgba(170, 208, 255, 0.45);
            border-radius: 18px;
            font-size: 16px;
            color: #fff;
            line-height: 36px;
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
            img{
              width: 20px;
              margin-right: 5px;
            }
          }
        }
      }

      .listBox {
        margin-top: 30px;
        height: 100%;

        .tabelTitle {
          width: 100%;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ebebeb;

          .titleLeft {
            min-width: 400px;
            max-height: 600px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #666;
            line-height: 30px;
          }

          .titleRight {
            display: flex;
            justify-content: space-between;

            .titleRightCenOne {
              font-size: 16px;
              color: #666666;
              line-height: 30px;
              width: 80px;
              text-align: center;
              margin-right: 10px;
            }

            .titleRightCenTwo {
              font-size: 16px;
              color: #666666;
              line-height: 30px;
              width: 200px;
              text-align: center;
            }
          }

        }

        .tabelBox {
          width: 100%;
          display: flex;
          padding: 5px 0;
          justify-content: space-between;
          margin-top: 20px;

          .tabelBoxTitleLeft {
            min-width: 400px;
            max-height: 700px;
            background: url('../../../../assets/images/Wicon.png') no-repeat center left;
            background-size: 19px 19px;
            padding-left: 28px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #333333;
            line-height: 30px;
            cursor: pointer;
          }
          .tabelBoxTitleLeft:hover {
            color: #0a2240;
          }

          .tabelBoxTitleRight {
            display: flex;
            justify-content: space-between;

            .tabelBoxTitleRightCenOne {
              font-size: 14px;
              color: #666666;
              line-height: 30px;
              width: 65px;
              text-align: center;
              margin-right: 10px;
            }

            .tabelBoxTitleRightCenTwo {
              font-size: 14px;
              color: #666666;
              line-height: 30px;
              width: 255px;
              text-align: center;

              .tabelBtnYl {
                padding: 2px 12px;
                font-size: 14px;
                background-color: #0a2240;
                border-radius: 13px;
                /*margin-right: 30px;*/
                cursor: pointer;
                color: #fff;
              }

              .tabelBtnBj {
                padding: 2px 12px;
                font-size: 14px;
                background-color: #0a2240;
                border-radius: 13px;
                color: #ffffff;
                cursor: pointer;
                margin-left: 10px;
              }
              .tabelBtndel {
                padding: 2px 12px;
                font-size: 14px;
                background-color: #fff;
                border-radius: 13px;
                color: #0a2240;
                border: 1px solid #0a2240;
                cursor: pointer;
                margin-left: 10px;
              }
            }
          }

        }

        .tabelNo {
          width: 100%;
          padding: 40px 0;
          text-align: center;
          font-size: 14px;
          color: #99a2aa;
        }

        .pageBox {
          margin-top: 80px;
          display: flex;
          justify-content: center;

          span {
            padding: 6px 10px;
            border-radius: 4px;
            background-color: #fff;
            border: 1px solid #f2f2f2;
            font-size: 14px;
            color: #666666;
            cursor: pointer;
          }

          .el-pagination {
            .el-pager {
              .active {
                background-color: #0a2240 !important; // 进行修改背景和字体
                color: #fff !important;
              }
            }
          }
        }
      }
    }
  }
</style>
